module.exports = __webpack_public_path__ + "static/media/aulao-presencial.da7e5a0b.png";